const internationalProgrammes = [
  {
    id: 101,
    cat: "international",
    destination: "vietnam-thailand",
    title: "فيتنام + تايلاند",
    route: "هانوي ← دا نانغ ← بانكوك",
    location: "هانوي، دا نانغ، بانكوك",
    days: 16,
    nights: 15,
    dates: "20/06 إلى 05/07",
    price: "28,800",
    currency: "DH",
    airline: "الخطوط الجوية التركية - توقف بإسطنبول",
    badge: "آسيا",
    type: "رحلة خارجية",
    img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1000&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=80",
      "https://images.unsplash.com/photo-1528127269322-539801943592?w=1200&q=80",
      "https://images.unsplash.com/photo-1508009603885-50cf7c579365?w=1200&q=80",
    ],
    summary: "رحلة آسيوية غنية تجمع بين ثقافة فيتنام، طبيعة دا نانغ، وحيوية بانكوك مع فنادق 4 نجوم وطيران تركي.",
    hotels: [
      { city: "هانوي", name: "Rey Hanoi Hotel", rating: "4.5★", nights: "" },
      { city: "دا نانغ", name: "Balcona Danang", rating: "4★", nights: "" },
      { city: "بانكوك", name: "Grand Mercure Bangkok Atrium", rating: "4.3★", nights: "" },
    ],
    itinerary: [
      { day: "اليوم الأول", title: "الانطلاقة", items: ["التجمع في مطار محمد الخامس الدار البيضاء", "التوقف بإسطنبول ثم الوصول إلى مطار هانوي"] },
      { day: "اليوم الثاني", date: "21/06", title: "الوصول إلى هانوي", items: ["الاستقبال في المطار", "الانتقال إلى الفندق وتسجيل الدخول", "وقت حر للراحة"] },
      { day: "اليوم الثالث", date: "22/06", title: "جولة مدينة هانوي", items: ["الإفطار في الفندق", "جولة كاملة في مدينة هانوي", "زيارة أهم المعالم والأسواق التقليدية"] },
      { day: "اليوم الرابع", date: "23/06", title: "رحلة Ninh Binh", items: ["رحلة يوم كامل لاستكشاف الطبيعة والمناظر الجبلية", "العودة إلى هانوي والمبيت"] },
      { day: "اليوم الخامس", date: "24/06", title: "خليج هالونغ", items: ["التوجه إلى Ha Long Bay", "كروز فاخر وجولة بحرية", "وجبة غداء متضمنة"] },
      { day: "اليوم السادس", date: "25/06", title: "يوم حر", items: ["راحة واستمتاع بالفندق", "إمكانية اقتراح أنشطة اختيارية"] },
      { day: "اليوم السابع", date: "26/06", title: "التوجه إلى دا نانغ", items: ["الانتقال إلى المطار", "الوصول إلى دا نانغ", "الاستقبال والانتقال إلى الفندق"] },
      { day: "اليوم الثامن", date: "27/06", title: "جولة دا نانغ", items: ["Son Tra Peninsula", "Linh Ung Pagoda", "Marble Mountains", "Han Market", "وقت حر لمشاهدة Fireworks"] },
      { day: "اليوم التاسع", date: "28/06", title: "دا نانغ ليلا", items: ["جولة في السوق الليلي", "مشاهدة Dragon Bridge"] },
      { day: "اليوم العاشر", date: "29/06", title: "Ba Na Hills", items: ["ركوب التلفريك", "زيارة Golden Bridge", "القرية الفرنسية القديمة", "غداء بوفيه في مطعم حلال"] },
      { day: "اليوم الحادي عشر", date: "30/06", title: "جولة Hoi An", items: ["Coconut Forest", "Hoi An Ancient Town", "Hoi An Night Market", "Japanese Covered Bridge"] },
      { day: "اليوم الثاني عشر", date: "01/07", title: "يوم حر", items: ["يوم حر مع إمكانية اختيار أنشطة حسب الطقس"] },
      { day: "اليوم الثالث عشر", date: "02/07", title: "التوجه إلى بانكوك", items: ["التوجه من الفندق إلى المطار", "الوصول إلى بانكوك", "وقت حر في المساء"] },
      { day: "اليوم الرابع عشر", date: "03/07", title: "بانكوك", items: ["يوم حر وسط المدينة", "وقت حر في المساء للتجول"] },
      { day: "اليوم الخامس عشر", date: "04/07", title: "المغادرة", items: ["الخروج من الفندق الساعة 12:00", "التوجه إلى مطار بانكوك الدولي"] },
      { day: "اليوم السادس عشر", date: "05/07", title: "الوصول إلى المغرب", items: ["الوصول إلى المغرب"] },
    ],
    includes: ["تذكرة الطيران مع الخطوط الجوية التركية ذهابا وإيابا", "طيران هانوي إلى دا نانغ", "طيران دا نانغ إلى بانكوك", "الفنادق مع الإفطار", "الجولات والأنشطة المذكورة", "3 وجبات غداء", "رسوم تأشيرة فيتنام"],
    notIncluded: ["الوجبات والمصاريف الشخصية", "الأنشطة الاختيارية", "تأمين السفر"],
  },
  {
    id: 102,
    cat: "international",
    destination: "thailand-phi-phi",
    title: "تايلاند وجزر فيفي",
    route: "بانكوك ← بوكيت ← جزر فيفي",
    location: "بانكوك، بوكيت، Phi Phi",
    days: 12,
    nights: 10,
    dates: "تواريخ شهرية من أبريل إلى أكتوبر",
    price: "21,500",
    currency: "DH",
    airline: "Turkish, Qatar, Etihad, Emirates, Saudia",
    badge: "جزر وشواطئ",
    type: "رحلة خارجية",
    img: "https://images.unsplash.com/photo-1508009603885-50cf7c579365?w=1000&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1508009603885-50cf7c579365?w=1200&q=80",
      "https://images.unsplash.com/photo-1537953773345-d172ccf13cf1?w=1200&q=80",
      "https://images.unsplash.com/photo-1528181304800-259b08848526?w=1200&q=80",
    ],
    summary: "برنامج تايلاند يجمع بين بانكوك، بوكيت، وجزر فيفي مع جولات بحرية وتجارب مغامرة وفنادق مختارة.",
    hotels: [
      { city: "بانكوك", name: "Grand Mercure Bangkok Atrium", rating: "4.3★" },
      { city: "بوكيت", name: "Novotel Phuket Vintage Park Resort", rating: "4.4★" },
      { city: "بوكيت", name: "Nap Patong / Deevana Plaza", rating: "4.4★ - 4.6★" },
    ],
    priceTable: [
      { label: "أبريل", value: "21,500 DH" },
      { label: "ماي", value: "21,500 DH" },
      { label: "يونيو", value: "25,000 DH" },
      { label: "يوليوز", value: "27,000 DH" },
      { label: "أغسطس", value: "28,000 DH" },
      { label: "سبتمبر", value: "28,000 DH" },
      { label: "أكتوبر", value: "25,000 DH" },
    ],
    itinerary: [
      { day: "اليوم الأول", title: "الوصول إلى بانكوك", items: ["استقبال في المطار", "نقل خاص إلى الفندق", "أمسية حرة"] },
      { day: "اليوم الثاني", title: "اكتشاف بانكوك", items: ["معبد بوذا", "القصر الملكي", "مول فاخر", "سوق ليلي تقليدي"] },
      { day: "اليوم الثالث", title: "يوم حر", items: ["إمكانية جولة نهر تشاو فرايا", "تسوق أو أنشطة اختيارية"] },
      { day: "اليوم الرابع", title: "السفر إلى بوكيت", items: ["نقل إلى المطار", "رحلة داخلية إلى بوكيت", "استقبال ونقل للفندق"] },
      { day: "اليوم الخامس", title: "معالم بوكيت", items: ["المدينة القديمة", "Wat Chalong", "Big Buddha", "Karon View Point"] },
      { day: "اليوم السادس", title: "يوم المغامرة", items: ["سفاري", "تجديف", "زيب لاين", "كواد", "تفاعل مع الفيلة", "غداء متضمن"] },
      { day: "اليوم السابع", title: "يوم حر", items: ["شاطئ أو أنشطة بحرية اختيارية"] },
      { day: "اليوم الثامن", title: "جزر فيفي", items: ["انتقال بالقارب السريع", "وقت حر في الجزيرة"] },
      { day: "اليوم التاسع", title: "جولة بحرية خاصة", items: ["شاطئ القرود", "بحيرة بيليه", "كهف الفايكنغ", "خليج مايا", "الغداء متضمن"] },
      { day: "اليوم العاشر", title: "العودة إلى بوكيت", items: ["انتقال بالقارب", "أمسية حرة"] },
      { day: "اليوم الحادي عشر", title: "المغادرة", items: ["نقل خاص إلى المطار", "رحلة العودة إلى المغرب"] },
    ],
    includes: ["رحلة الدار البيضاء إلى بانكوك/بوكيت والعودة", "الطيران الداخلي بانكوك إلى بوكيت", "10 ليالي في الفنادق", "وجبات الإفطار", "وجبتا غداء", "تذاكر القارب ذهابا وإيابا", "الجولات المذكورة", "الدليل والإرشاد", "حافلة مكيفة"],
    notIncluded: ["الوجبات والمصاريف الشخصية", "أنشطة الأيام الحرة", "تأمين السفر"],
  },
  {
    id: 103,
    cat: "international",
    destination: "kuala-bali",
    title: "كوالا لمبور + بالي",
    route: "كوالا لمبور ← بالي ← كوالا لمبور",
    location: "ماليزيا، بالي",
    days: 15,
    nights: 13,
    dates: "رحلتان شهريا من أبريل إلى نونبر 2026",
    price: "21,400",
    currency: "DH",
    airline: "Turkish, Saudia, Qatar, Etihad, Emirates",
    badge: "ماليزيا وبالي",
    type: "رحلة خارجية",
    img: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=1000&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=1200&q=80",
      "https://images.unsplash.com/photo-1508964942454-1a56651d54ac?w=1200&q=80",
      "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=1200&q=80",
    ],
    summary: "رحلة طويلة ومليئة بالأنشطة بين كوالا لمبور وبالي: شواطئ، أوبود، كوتا، سيمينياك، وخرجـات داخلية غنية.",
    hotels: [
      { city: "كوالا لمبور", name: "Royal Signature Bukit Bintang", rating: "5★", nights: "4 ليالي" },
      { city: "بالي - كوتا", name: "Discovery Kartika Plaza", rating: "5★", nights: "3 ليالي" },
      { city: "بالي - أوبود", name: "Swan Paradise", rating: "4★", nights: "4 ليالي" },
      { city: "بالي - سيمينياك", name: "Jambuluwuk Oceano", rating: "5★", nights: "2 ليالي" },
    ],
    priceTable: [
      { label: "أبريل", value: "21,400 DH" },
      { label: "ماي", value: "22,900 DH" },
      { label: "يونيو", value: "23,900 DH" },
      { label: "يوليوز", value: "26,300 DH" },
      { label: "أغسطس", value: "26,800 DH" },
      { label: "سبتمبر", value: "26,300 / 25,300 DH" },
      { label: "أكتوبر", value: "22,900 DH" },
      { label: "نونبر", value: "21,400 DH" },
    ],
    itinerary: [
      { day: "اليوم الأول", title: "الانطلاقة", items: ["التجمع في مطار محمد الخامس", "رحلة دولية نحو كوالا لمبور"] },
      { day: "اليوم الثاني", title: "الوصول إلى كوالا لمبور", items: ["استقبال محلي", "الانتقال إلى الفندق", "جولة ليلية في المولات وأبراج بيتروناس"] },
      { day: "اليوم الثالث", title: "جولة العاصمة", items: ["كهوف باتو", "المعبد الصيني", "مسجد ناكارا", "ساحة الاستقلال"] },
      { day: "اليوم الرابع", title: "الانتقال إلى بالي", items: ["رحلة AirAsia أو BatikAir", "استقبال بقلادة زهور", "المبيت في كوتا"] },
      { day: "اليوم السادس", title: "جنوب بالي", items: ["Tanjung Benoa", "Banana Boat", "Melasti Beach", "عرض Kecak", "غداء متضمن"] },
      { day: "اليوم السابع", title: "قرى أوبود", items: ["Glass Bridge Bali", "Rainbow Slide", "Peliatan Royal Palace", "Taman Dedari", "مزارع القهوة"] },
      { day: "اليوم التاسع", title: "أنشطة أوبود", items: ["Rafting في نهر Ayung", "D'Tukad Coffee Club", "Aloha Swing"] },
      { day: "اليوم الحادي عشر", title: "بدوغول وسيمينياك", items: ["Ulun Danu Beratan Temple", "Handara Golf Resort", "Wanagiri Hidden Hill"] },
      { day: "اليوم الثاني عشر", title: "جزر اختيارية", items: ["Nusa Penida أو Nusa Lembongan", "شواطئ، مناظر، وغداء حسب الجولة"] },
      { day: "اليوم الخامس عشر", title: "العودة إلى المغرب", items: ["مغادرة الفندق", "التوجه للمطار", "العودة للمغرب"] },
    ],
    includes: ["رحلة دولية ذهابا وإيابا", "رحلة داخلية كوالا لمبور - بالي ذهابا وإيابا", "13 ليلة في الفنادق", "وجبات الإفطار", "جولات وأنشطة مذكورة", "مرافق يتحدث العربية أو الدارجة المغربية"],
    notIncluded: ["المصاريف الشخصية", "بعض الأنشطة الاختيارية", "أي خدمة غير مذكورة"],
    notes: ["التسبيق: 10,000 DH، و15,000 DH في يوليوز وغشت وسبتمبر", "تتمة المبلغ قبل الرحلة بـ 10 أيام", "لا يمكن إلغاء الحجز في حال صدور تذكرة الطيران"],
  },
  {
    id: 104,
    cat: "international",
    destination: "maldives-srilanka-istanbul",
    title: "المالديف + سريلانكا + إسطنبول",
    route: "المالديف ← سريلانكا ← إسطنبول",
    location: "المالديف، سريلانكا، إسطنبول",
    days: 11,
    nights: 10,
    dates: "30/04 إلى 10/05",
    price: "32,500",
    currency: "DH",
    airline: "رحلة دولية متعددة الوجهات",
    badge: "فنادق 5 نجوم",
    type: "رحلة خارجية",
    img: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=1000&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=1200&q=80",
      "https://images.unsplash.com/photo-1546708973-b339540b5162?w=1200&q=80",
      "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=1200&q=80",
    ],
    summary: "برنامج راق يجمع بين راحة جزر المالديف، طبيعة ومغامرات سريلانكا، ولمسة ختامية في إسطنبول.",
    hotels: [{ city: "كل الوجهات", name: "فنادق مختارة 5 نجوم", rating: "5★", nights: "" }],
    itinerary: [
      { day: "اليوم الأول", title: "الوصول إلى المالديف", items: ["الوصول إلى مطار المالديف", "قارب سريع إلى جزيرة MARINA", "وقت حر"] },
      { day: "اليوم الثاني إلى الرابع", title: "أيام حرة في الجزيرة", items: ["استمتاع بالجزيرة والشاطئ والمنتجع"] },
      { day: "اليوم الخامس", title: "الانتقال إلى سريلانكا", items: ["قارب سريع إلى المطار", "الوصول إلى سريلانكا", "جولة في كولومبو"] },
      { day: "اليوم السادس", title: "كولومبو إلى دامبولا", items: ["MAHA RAJA ELEPHANT VILLAGE", "Tuk Tuk", "الوصول إلى فندق دامبولا"] },
      { day: "اليوم السابع", title: "هابـارانا والسفاري", items: ["Habarana Old Village Tour", "Bullock Cart Ride", "Lake Rafting", "سفاري بين الفيلة"] },
      { day: "اليوم الثامن", title: "دامبولا إلى كولومبو", items: ["Ayurvedic Herbal Garden", "Kandy Lake", "Gem Museum"] },
      { day: "اليوم التاسع", title: "كولومبو", items: ["جولة في مدينة كولومبو"] },
      { day: "اليوم العاشر", title: "إسطنبول", items: ["الانتقال من المطار إلى الفندق", "وقت حر"] },
      { day: "اليوم الحادي عشر", title: "العودة إلى المغرب", items: ["رحلة العودة"] },
    ],
    includes: ["فنادق 5 نجوم", "الفطور والعشاء", "التنقلات المذكورة", "الجولات المذكورة في البرنامج"],
    notIncluded: ["المصاريف الشخصية", "الأنشطة الاختيارية", "أي خدمة غير مذكورة"],
  },
  {
    id: 105,
    cat: "international",
    destination: "istanbul",
    title: "إسطنبول",
    route: "الدار البيضاء ← إسطنبول ← الدار البيضاء",
    location: "إسطنبول",
    days: 8,
    nights: 7,
    dates: "تواريخ متعددة من أبريل إلى يوليوز",
    price: "7,990",
    currency: "DH",
    airline: "الخطوط الملكية المغربية",
    badge: "3 خرجات مجانية",
    type: "رحلة خارجية",
    img: "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=1000&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=1200&q=80",
      "https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?w=1200&q=80",
      "https://images.unsplash.com/photo-1510253687831-0f982d7862fc?w=1200&q=80",
    ],
    summary: "برنامج إسطنبول 8 أيام مع فندق 4 نجوم، الخطوط الملكية المغربية، 56 كلغ أمتعة، وثلاث خرجات مبرمجة مجانا.",
    hotels: [{ city: "إسطنبول", name: "Grand Asiyan Hotel", rating: "4★", location: "لاليلي، 200م من محطة الترام، مسبح داخلي وحمام تركي" }],
    priceTable: [
      { label: "12/04 → 19/04", value: "7,990 DH" },
      { label: "25/04 → 02/05", value: "8,290 DH" },
      { label: "01/05 → 08/05", value: "8,700 DH" },
      { label: "02/05 → 09/05", value: "8,900 DH" },
      { label: "17/05 → 24/05", value: "8,190 DH" },
      { label: "21/06 → 28/06", value: "10,390 DH" },
      { label: "28/06 → 05/07", value: "10,390 DH" },
    ],
    itinerary: [
      { day: "اليوم الأول", title: "الاستقبال", items: ["التجمع بمطار محمد الخامس", "الاستقبال بمطار إسطنبول", "التوجه إلى الفندق والتعريف بالمحيط"] },
      { day: "اليوم الثاني", title: "بيرلوتي وبلاط", items: ["هضبة بييرلوتي بالتلفريك", "مسجد أيوب الأنصاري", "حي بلاط", "مول فينيزيا"] },
      { day: "اليوم الثالث", title: "البوسفور وفلوريا", items: ["جولة البوسفور بسفينة خاصة", "مول فلوريا", "أكواريوم فلوريا اختياري", "مول أوليفيوم"] },
      { day: "اليوم الرابع", title: "يوم حر", items: ["أنشطة اختيارية", "تسوق بالأسواق الشعبية"] },
      { day: "اليوم الخامس", title: "الجهة الآسيوية", items: ["تلة العرائس", "مسجد تشامليجا", "كاديكوي", "أورطاكوي"] },
      { day: "اليوم السادس", title: "سبانجا اختيارية", items: ["قمة كاربتيه", "الشرفة الزجاجية", "غداء بمنطقة سوبيلي", "بحيرة سبانجا"] },
      { day: "اليوم السابع", title: "سهرة البوسفور اختيارية", items: ["يوم حر", "سهرة موسيقية تركية", "عشاء ونقل خاص"] },
      { day: "اليوم الثامن", title: "العودة", items: ["تسليم الغرف", "التوجه للمطار", "رحلة العودة"] },
    ],
    includes: ["تذاكر الطائرة مع الخطوط الملكية المغربية", "7 ليالي بفندق 4 نجوم", "النقل من وإلى الفندق", "وجبات الإفطار", "البرنامج الأساسي 3 أيام مجانا", "مرافق مغربي", "56 كلغ أمتعة"],
    notIncluded: ["رحلة سبانجا 300 DH", "سهرة البوسفور 390 DH", "أكواريوم فلوريا", "أنشطة الأيام الحرة"],
    notes: ["آخر أجل للحجز 15 يوما قبل الرحلة", "تأكيد الحجز لا يقل عن 7,000 DH", "جواز صالح 6 أشهر بعد العودة", "تأمين السفر اختياري"],
  },
  {
    id: 106,
    cat: "international",
    destination: "egypt",
    title: "مصر: القاهرة + الإسكندرية + شرم الشيخ",
    route: "القاهرة ← الإسكندرية ← شرم الشيخ",
    location: "القاهرة، الإسكندرية، شرم الشيخ",
    days: 10,
    nights: 8,
    dates: "يوليوز وغشت",
    price: "15,950",
    currency: "DH",
    airline: "طيران دولي مباشر وداخلي",
    badge: "مصر",
    type: "رحلة خارجية",
    img: "https://images.unsplash.com/photo-1539650116574-8efeb43e2750?w=1000&q=80",
    gallery: [
      "https://images.unsplash.com/photo-1539650116574-8efeb43e2750?w=1200&q=80",
      "https://images.unsplash.com/photo-1572252009286-268acec5ca0a?w=1200&q=80",
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=1200&q=80",
    ],
    summary: "رحلة مصرية تجمع بين آثار القاهرة، يومية الإسكندرية، وإقامة شاطئية شاملة في شرم الشيخ.",
    hotels: [
      { city: "القاهرة", name: "Gewan Hotel Cairo Tulip Golden Plaza", rating: "4.2★" },
      { city: "شرم الشيخ", name: "Sharks Bay Resort / Dreams Beach Resort", rating: "4.4★ - 5★" },
    ],
    priceTable: [
      { label: "يوليوز - غرفة ثنائية", value: "15,950 DH" },
      { label: "يوليوز - غرفة فردية", value: "18,950 DH" },
      { label: "غشت - غرفة ثنائية", value: "16,450 DH" },
      { label: "غشت - غرفة فردية", value: "19,450 DH" },
    ],
    itinerary: [
      { day: "اليوم الأول", title: "الانطلاق", items: ["التجمع بمطار محمد الخامس", "طيران مباشر إلى القاهرة"] },
      { day: "اليوم الثاني", title: "الوصول إلى القاهرة", items: ["استقبال في المطار", "فطور مصري تقليدي", "استلام الغرف", "زيارة City Star"] },
      { day: "اليوم الثالث", title: "الأهرامات والمتحف", items: ["الأهرامات وأبو الهول", "بانوراما الأهرامات", "مصنع البرديات", "المتحف المصري الكبير"] },
      { day: "اليوم الرابع", title: "الإسكندرية", items: ["قلعة قايتباي", "مكتبة الإسكندرية", "مسجد المرسي أبو العباس", "كوم الشقافة", "متحف المجوهرات"] },
      { day: "اليوم الخامس", title: "القاهرة الإسلامية", items: ["مسجد الحسين", "مسجد عمرو بن العاص", "الأزهر", "خان الخليلي وشارع المعز"] },
      { day: "اليوم السادس", title: "شرم الشيخ", items: ["طيران داخلي إلى شرم الشيخ", "تسجيل الوصول", "إقامة شاملة"] },
      { day: "اليوم السابع إلى التاسع", title: "شرم الشيخ", items: ["شاطئ ومسبح", "أنشطة بحرية اختيارية", "رأس محمد أو جزيرة تيران اختيارية"] },
      { day: "اليوم العاشر", title: "العودة", items: ["الإفطار", "التوجه إلى مطار شرم الشيخ", "العودة إلى الوطن"] },
    ],
    includes: ["طيران دولي مباشر إلى القاهرة", "عودة دولية من شرم الشيخ", "طيران داخلي القاهرة - شرم الشيخ", "4 ليال في القاهرة مع الإفطار", "4 ليال في شرم الشيخ بنظام شامل", "يومية الإسكندرية", "الجولات السياحية المذكورة"],
    notIncluded: ["500 DH رسوم الفيزا", "20 دولار إكراميات عند الوصول", "الجولات الاختيارية", "المصاريف الشخصية"],
    notes: ["عند الحجز 50%", "عند خروج الفيزا 25%", "عند إصدار التذاكر الدولية والداخلية 25%", "العرض غير قابل للاسترداد بعد خروج الفيزا"],
  },
];

export default internationalProgrammes;
